module.exports = __webpack_public_path__ + "img/ol.fe1a5f99.svg";